import { gql } from "@apollo/client"

export const UPDATE_PAYMENT_METHOD = gql`mutation UpdatePaymentMethod ($input: UpdatePaymentMethodInput!) {
  updatePaymentMethodAndPayInvoice (updatePaymentMethodData: $input) {
  id,
  status,
  payment_intent
  }
}`
